// Register.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLocation } from 'react-router-dom';  // Import useLocation to read passed state

import { ReactComponent as LoginIcon } from '../icons/login.svg';
import { ReactComponent as ProchildIcon } from '../icons/prochild.svg';
import { ReactComponent as EnvelopeIcon } from '../icons/envelope.svg';
import { ReactComponent as CircleIcon } from '../icons/circleGreen.svg';
import { ReactComponent as TriangleIcon } from '../icons/triangle.svg';
import styles from './Login&Register.module.css';

import { API_BASE_URL } from './Common';
const registerUrl = `${API_BASE_URL}/users/register`;
const verifyUrl = `${API_BASE_URL}/users/verify`;
const resendUrl = `${API_BASE_URL}/users/resend-verification`;

function Register() {
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [confirmationCode, setConfirmationCode] = useState(['', '', '', '', '', '']);
  const [step, setStep] = useState(1);

  useEffect(() => {
    // Pre-fill the email input if email is passed from the login page
    if (location.state && location.state.email) {
      setEmail(location.state.email);
      setStep(2);
    }
  }, [location.state]);

  useEffect(() => {
    if (email && step === 2) {
      handleResendEmail(); // Call handleResendEmail only when email is set and step is 2
    }
  }, [email, step]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
        document.getElementById("password").classList.add(styles.inputError);
      //setError("Passwords don't match. Please try again.");
      return;
    }
    if (password.length < 8 || !/\d/.test(password)) {
    // Check for password length and presence of at least 1 number
    //setError("A sua password deverá conter pelo menos 8 caracteres e um algarismo");
    document.getElementById("createpassword").classList.add(styles.inputError);
    return;
  }
    if (username.includes('@')) {
    setError("Username cannot contain '@' symbol. Please choose a different username.");
    return;
  }

    try {
      const response = await axios.post(registerUrl, { username, email, password });
      // Assuming the response contains a success message upon successful registration
      setSuccessMessage(response.data.message);
      setError("");
      setStep(2);
    } catch (error) {
      if (error.response.status === 400) {
        document.getElementById("nome").classList.add(styles.inputError);
        document.getElementById("email").classList.add(styles.inputError);
      //setError("Nome ou e-mail já existem");

      }

    }
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(verifyUrl, { email, confirmationCode: confirmationCode.join('') });
      // Assuming the response contains a success message upon successful verification
      setSuccessMessage(response.data.message);
      setUsername('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setConfirmationCode(['', '', '', '', '', '']);
      setStep(3);
    } catch (error) {
      await handleResendEmail();
      setConfirmationCode(['', '', '', '', '', '']);
      setStep(4);
      setError(error.response.data.message);
    }
  };

  const handleConfirmationCodeChange = (value, index) => {
    const newCode = [...confirmationCode];
    newCode[index] = value;
    setConfirmationCode(newCode);

    // Automatically focus the next input field
    if (value.length === 1 && index < 5) {
      document.getElementById(`confirmationCode${index + 1}`).focus();
    }
  };


  const handleResendEmail = async () => {
    try {
      const response = await axios.post(resendUrl, { email });
      setSuccessMessage(response.data.message);
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  return (
    <>
    {step === 1 ? (
    <div className={styles.loginWrapper}>
    <div className={styles.loginContainer}>
    <ProchildIcon/>

      <div className={styles.bigText}>Criar conta</div>
      <p className={styles.welcomeText}>Comece a criar belos dashboards!</p>

      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <div className={styles.formGroup}>
          <label>Nome</label>
          <input
          id="nome"
          placeholder="Inserir nome"
          type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div className={styles.formGroup}>
          <label>E-mail</label>
          <input
          id="email"
          placeholder="Inserir e-mail"
          type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className={styles.formGroup}>
          <label>Password*</label>
          <input
          id="createpassword"
          placeholder="Criar password"
          type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div className={styles.formGroup}>
          <label>Confirmar Password*</label>
          <input
          id="password"
          placeholder="Confirmar password"
          type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
        </div>
{/*
        {error && <p className={styles.errorMessage}>{error}</p>}
        {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
*/}
        <p className={styles.welcomeText}>A sua password deverá conter pelo menos 8 caracteres e um algarismo.</p>
        <button type="submit" className={styles.loginBtn} >Começar!</button>
      </form>

      <div className={styles.linkContainer}>
        <Link to="/" className={styles.myLinks}>Login?</Link>
      </div>
    </div>
    <LoginIcon className={styles.loginIcon} />
    </div>
    ):

    (

<div className={styles.recoveryContainer}>
    <LoginIcon className={styles.loginIcon2}/>

      {step === 2 ? <EnvelopeIcon className={styles.keyIcon}/> :
      (step === 3 ? <CircleIcon className={styles.keyIcon}/> :
      (step === 4 ? <TriangleIcon className={styles.keyIcon}/> :
      null))
      }

    <div className={styles.bigText2}>
      {step === 2 ? "Introduza o código de verificação" :
      (step === 3 ? <span style={{ color: '#43BBC9' }}>E-mail verificado</span> :
      (step === 4 ? <span style={{ color: '#E5004E' }}>Código errado</span> :
      null))}
    </div>

    <div className={styles.welcomeText2}>
  <>
    {step === 3 && (
      <>
        A sua conta de e-mail foi verificada.
        <br />
        Clique abaixo para fazer login.
      </>
    )}
    {step === 4 && (
      <>
        Introduza o novo código enviado.
      </>
    )}
  </>
</div>



<form onSubmit={handleVerify} className={styles.recoveryForm}>
              <div className={styles.formGroup}>
                  <div className={styles.confirmationCodeContainer}>
{step !== 3 && ( <>
                {confirmationCode.map((digit, index) => (

                  <input
                    key={index}
                    id={`confirmationCode${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleConfirmationCodeChange(e.target.value, index)}
                    required
                    style={{
                      width: '55px', // Adjust the width to look like a square
                      height: '55px', // Same as width to make it square
                      textAlign: 'center',
                      fontSize: '32px',
                      fontWeight: '700',
                      lineHeight: '37.5px',
                      fontFamily: 'Roboto',
                      border: '1px solid #43BBC9',
                      borderRadius: '5px', // Slight rounding for better appearance
                      margin: '0px',
                      color: '#43BBC9' // Background color
                    }}
                  />
                ))}
  </>
)}
              </div>

              </div>
{/*
              {error && <p className={styles.errorMessage}>{error}</p>}
              {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
*/}

      {step === 2 ? <button type="submit" className={styles.loginBtn}>Verificar e-mail</button> :
      (step === 3 ? <Link to="/">
        <button
          className={styles.loginBtn}
        >
          Login
        </button>
    </Link> :
      (step === 4 ? <button type="submit" className={styles.loginBtn}>Verificar e-mail</button> :
      null))
      }


            </form>


{step !== 3 && ( <>
      <div className={styles.linkContainer}>

      <span className={styles.welcomeText2}>
  Não recebeu o e-mail? Clique
</span>&nbsp;
        <span
            className={styles.myLinks}
            onClick={handleResendEmail}
          >
            aqui
          </span>
      </div>
  </>
)}

<div className={styles.linkContainer}>
      <ProchildIcon className={styles.loginIcon3}/>
      </div>

</div>
    )}
    </>

  );
}

export default Register;


